import React from "react";
import { useIntl } from "@leagueplatform/locales";
import { useDocumentTitle } from "@leagueplatform/web-common";
import {
  Box,
  HeadingText,
  ParagraphText,
  StackItem,
  StackLayout,
  Image,
} from "@leagueplatform/genesis-core";
import QUEST_CIRCLE_LOGO from "assets/quest/quest_logo_circle.svg";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useIsBelowTablet } from "hooks/use-is-below-tablet.hook";

const PAGE_CONTENT_MAX_WIDTH = 952;
// const MASONRY_CONTENT_MAX_WIDTH = 644;

export const AboutPage = () => {
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: "STR_ABOUT_QUEST" }));
  usePageViewAnalytics({ screen_name: "About" });

  const isBelowTablet = useIsBelowTablet();

  return (
    <>
      <Box
        css={{
          backgroundColor: "$surfaceBackgroundTertiary",
          height: isBelowTablet ? "auto" : 140,
          paddingInline: "$two",
          paddingBlock: isBelowTablet ? "$two" : "$none",
        }}
      >
        <StackLayout
          orientation="horizontal"
          verticalAlignment="center"
          css={{
            maxWidth: PAGE_CONTENT_MAX_WIDTH,
            marginInline: "auto",
            height: "100%",
          }}
        >
          <HeadingText level="1" size={isBelowTablet ? "xl" : "xxl"}>
            {formatMessage({ id: "STR_ABOUT_QUEST" })}
          </HeadingText>
        </StackLayout>
      </Box>

      <Box
        css={{
          marginInline: "auto",
          paddingInline: "$two",
          paddingBlock: "$two",
          maxWidth: PAGE_CONTENT_MAX_WIDTH,
          "@mobile": {
            paddingInline: "$one",
          },
        }}
      >
        <StackLayout
          orientation={{ "@initial": "horizontal", "@mobile": "vertical" }}
          horizontalAlignment="center"
          spacing={{ "@initial": "$twoAndHalf", "@mobile": "$two" }}
          css={{
            maxWidth: PAGE_CONTENT_MAX_WIDTH,
            marginInline: "auto",
            "@mobile": {
              boxShadow: "0px 4px 8px -2px #18274B0F",
              padding: "$oneAndHalf",
            },
          }}
        >
          <Image
            width="98px"
            src={QUEST_CIRCLE_LOGO}
            alt={formatMessage({ id: "STR_QUEST_CIRCLE_LOGO" })}
          />
          <StackItem>
            <ParagraphText
              css={{ typography: "$bodyOne", color: "$onSurfaceTextPrimary" }}
            >
              {formatMessage({ id: "STR_ABOUT_QUEST_DESCRIPTION" })}
            </ParagraphText>
          </StackItem>
        </StackLayout>
      </Box>
    </>
  );
};
